// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchInMiddle {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 2rem;
}

.modal {
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
}
.modal__beside {
  display: flex;
  gap: 2rem;
  width: 38rem;
  justify-content: space-between;
}
.modal__beside__grid {
  display: grid;
  width: 38rem;
  gap: 2rem;
  grid-template-columns: 1fr 1fr;
}
.modal__checks {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
}
.modal__checks_group {
  align-self: center;
}
.modal__borderBottom {
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--color-primary);
  margin-bottom: 2rem;
}
.modal__list {
  width: 38rem;
}
.modal__list > :not(:last-child) {
  margin-bottom: 1rem;
}
.modal__h__line {
  content: "";
  border-top: 1px solid var(--color-dark);
  margin: 2rem 0;
  width: 38rem;
}
.modal__switcher {
  width: 38rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  border: 1px solid var(--color-dark);
  border-radius: 1rem;
  font-size: var(--default-font-small);
  cursor: pointer;
  margin-bottom: 2rem;
}
.modal__switcher > * {
  padding: 1rem;
  display: flex;
  justify-content: center;
}
.modal__switcher__a {
  border-radius: 1rem 0 0 1rem;
}
.modal__switcher__b {
  border-radius: 0 1rem 1rem 0;
}
.modal__switcher__active {
  background-color: var(--color-dark);
  color: var(--color-white);
  font-weight: 700;
  transition: all 0.4s;
}

.whiteTable {
  width: 100%;
  margin-top: 3rem;
  font-size: var(--default-font-small);
  overflow-x: scroll;
}
.whiteTable::-webkit-scrollbar {
  width: 0;
  height: 0.7rem;
  background: var(--color-white);
}
.whiteTable::-webkit-scrollbar-thumb {
  background: var(--color-grey);
  border-radius: 2rem;
}
.whiteTable table {
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  width: 100%;
}
.whiteTable tr {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--color-grey-4);
}
.whiteTable tr > * {
  margin-right: 1rem;
}
.whiteTable td,
.whiteTable th {
  line-height: 4rem;
  padding: 2rem 0;
  width: 100%;
}

.filter_content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.filter_content > :not(last-child) {
  margin-right: 1rem;
}

.noInsights {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-error);
  font-size: var(--default-font-subtitle);
  text-align: center;
  height: 70%;
}

.tableAction__text {
  font-weight: 700;
  cursor: pointer;
}
.tableAction__text:hover {
  color: var(--color-primary);
}

.status {
  display: flex;
  font-weight: 700;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  width: 14rem;
  font-size: 1.2rem;
}
.status__th {
  display: flex;
  justify-content: center;
  width: 14rem;
}
.status__dark__yellow {
  color: var(--color-dark-yellow);
  background-color: var(--color-light-yellow);
  border: 0.5px solid var(--color-dark-yellow);
}
.status__green {
  color: var(--color-green);
  background-color: var(--color-light-green);
  border: 0.5px solid var(--color-green);
}
.status__green2 {
  color: var(--color-green);
  background-color: var(--color-green-3);
  border: 0.5px solid var(--color-green);
}
.status__red {
  color: var(--color-error);
  background-color: var(--color-light-red);
  border: 0.5px solid var(--color-error);
}
.status__grey {
  color: var(--color-grey-2);
  background-color: var(--color-light-grey);
  border: 0.5px solid var(--color-grey-2);
}
.status__blue {
  color: var(--color-primary);
  background-color: var(--color-primary-7);
  border: 0.5px solid var(--color-primary);
}

.cards_green_1 {
  background-color: var(--color-green);
  color: var(--color-white);
}
.cards_green_2 {
  background-color: var(--color-green-2);
}
.cards_green_3 {
  background-color: var(--color-success);
  color: var(--color-white);
}
.cards_red_1 {
  background-color: var(--color-error);
  color: var(--color-white);
}
.cards_red_2 {
  background-color: var(--color-light-red);
}
.cards_red_3 {
  background-color: var(--color-deep-red);
  color: var(--color-white);
}
.cards_red_4 {
  background-color: var(--color-red);
  color: var(--color-white);
}
.cards_red_5 {
  background-color: var(--color-red-2);
  color: var(--color-white);
}
.cards_yellow_1 {
  background-color: var(--color-yellow-2);
}
.cards_yellow_2 {
  background-color: var(--color-yellow);
}
.cards_yellow_3 {
  background-color: var(--color-yellow-3);
  color: var(--color-white);
}
.cards_blue_1 {
  background-color: var(--color-primary-3);
}
.cards_blue_2 {
  background-color: var(--color-primary-7);
}
.cards_blue_3 {
  background-color: var(--color-primary-8);
}
.cards_blue_4 {
  background-color: var(--color-primary-9);
}

.main_nav {
  display: flex;
  margin: 2rem 0;
  border-bottom: solid 1px var(--color-dark);
  gap: 2rem;
  width: fit-content;
  flex-wrap: wrap;
}
.main_nav_item {
  cursor: pointer;
  padding: 1rem 0;
  font-size: var(--default-font-small);
}
.main_nav_item_active {
  cursor: pointer;
  padding: 1rem 0;
  font-weight: 700;
  border-bottom: solid 2px var(--color-dark);
}
.main_nav_item:hover, .main_nav_item:focus, .main_nav_item:focus-visible, .main_nav_item:focus-within {
  font-weight: 700;
}

.error {
  font-size: var(--default-font-small);
  color: var(--color-error);
  font-weight: 400;
  margin: 1rem 0;
  max-width: 38rem;
}

.font__700 {
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Global/GlobalStyles.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;AADF;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;AADF;AAGE;EACE,aAAA;EACA,SAAA;EACA,YAAA;EACA,8BAAA;AADJ;AAGI;EACE,aAAA;EACA,YAAA;EACA,SAAA;EACA,8BAAA;AADN;AAKE;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;AAHJ;AAKI;EACE,kBAAA;AAHN;AAOE;EACE,oBAAA;EACA,6CAAA;EACA,mBAAA;AALJ;AAQE;EACE,YAAA;AANJ;AAQI;EACE,mBAAA;AANN;AAUE;EACE,WAAA;EACA,uCAAA;EACA,cAAA;EACA,YAAA;AARJ;AAWE;EACE,YAAA;EACA,aAAA;EACA,qCAAA;EACA,mCAAA;EACA,mBAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;AATJ;AAWI;EACE,aAAA;EACA,aAAA;EACA,uBAAA;AATN;AAYI;EACE,4BAAA;AAVN;AAaI;EACE,4BAAA;AAXN;AAcI;EACE,mCAAA;EACA,yBAAA;EACA,gBAAA;EACA,oBAAA;AAZN;;AAiBA;EACE,WAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;AAdF;AAgBE;EACE,QAAA;EACA,cAAA;EACA,8BAAA;AAdJ;AAiBE;EACE,6BAAA;EACA,mBAAA;AAfJ;AAkBE;EACE,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;AAhBJ;AAmBE;EACE,aAAA;EACA,8BAAA;EACA,4CAAA;AAjBJ;AAmBI;EACE,kBAAA;AAjBN;AAqBE;;EAEE,iBAAA;EACA,eAAA;EACA,WAAA;AAnBJ;;AAwBE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AArBJ;AAuBI;EACE,kBAAA;AArBN;;AA0BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,uCAAA;EACA,kBAAA;EACA,WAAA;AAvBF;;AA2BE;EACE,gBAAA;EACA,eAAA;AAxBJ;AA0BI;EACE,2BAAA;AAxBN;;AA6BA;EACE,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AA1BF;AA4BE;EACE,aAAA;EACA,uBAAA;EACA,YAAA;AA1BJ;AA6BE;EACE,+BAAA;EACA,2CAAA;EACA,4CAAA;AA3BJ;AA8BE;EACE,yBAAA;EACA,0CAAA;EACA,sCAAA;AA5BJ;AA+BE;EACE,yBAAA;EACA,sCAAA;EACA,sCAAA;AA7BJ;AAgCE;EACE,yBAAA;EACA,wCAAA;EACA,sCAAA;AA9BJ;AAiCE;EACE,0BAAA;EACA,yCAAA;EACA,uCAAA;AA/BJ;AAkCE;EACE,2BAAA;EACA,wCAAA;EACA,wCAAA;AAhCJ;;AAsCI;EACE,oCAAA;EACA,yBAAA;AAnCN;AAsCI;EACE,sCAAA;AApCN;AAuCI;EACE,sCAAA;EACA,yBAAA;AArCN;AA0CI;EACE,oCAAA;EACA,yBAAA;AAxCN;AA2CI;EACE,wCAAA;AAzCN;AA4CI;EACE,uCAAA;EACA,yBAAA;AA1CN;AA6CI;EACE,kCAAA;EACA,yBAAA;AA3CN;AA8CI;EACE,oCAAA;EACA,yBAAA;AA5CN;AAiDI;EACE,uCAAA;AA/CN;AAkDI;EACE,qCAAA;AAhDN;AAmDI;EACE,uCAAA;EACA,yBAAA;AAjDN;AAsDI;EACE,wCAAA;AApDN;AAuDI;EACE,wCAAA;AArDN;AAwDI;EACE,wCAAA;AAtDN;AAyDI;EACE,wCAAA;AAvDN;;AA6DE;EACE,aAAA;EACA,cAAA;EACA,0CAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AA1DJ;AA4DI;EACE,eAAA;EACA,eAAA;EACA,oCAAA;AA1DN;AA4DM;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,0CAAA;AA1DR;AA6DM;EAIE,gBAAA;AA9DR;;AAoEA;EACE,oCAAA;EACA,yBAAA;EAEA,gBAAA;EACA,cAAA;EACA,gBAAA;AAlEF;;AAsEE;EACE,gBAAA;AAnEJ","sourcesContent":["@import \"../variables/breakpoints\";\n\n.searchInMiddle {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  margin-top: 2rem;\n}\n\n.modal {\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n\n  &__beside {\n    display: flex;\n    gap: 2rem;\n    width: 38rem;\n    justify-content: space-between;\n\n    &__grid {\n      display: grid;\n      width: 38rem;\n      gap: 2rem;\n      grid-template-columns: 1fr 1fr;\n    }\n  }\n\n  &__checks {\n    display: flex;\n    justify-content: space-between;\n    margin: 1rem 0 2rem 0;\n\n    &_group {\n      align-self: center;\n    }\n  }\n\n  &__borderBottom {\n    padding-bottom: 1rem;\n    border-bottom: 1px solid var(--color-primary);\n    margin-bottom: 2rem;\n  }\n\n  &__list {\n    width: 38rem;\n\n    & > :not(:last-child) {\n      margin-bottom: 1rem;\n    }\n  }\n\n  &__h__line {\n    content: \"\";\n    border-top: 1px solid var(--color-dark);\n    margin: 2rem 0;\n    width: 38rem;\n  }\n\n  &__switcher {\n    width: 38rem;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    border: 1px solid var(--color-dark);\n    border-radius: 1rem;\n    font-size: var(--default-font-small);\n    cursor: pointer;\n    margin-bottom: 2rem;\n\n    & > * {\n      padding: 1rem;\n      display: flex;\n      justify-content: center;\n    }\n\n    &__a {\n      border-radius: 1rem 0 0 1rem;\n    }\n\n    &__b {\n      border-radius: 0 1rem 1rem 0;\n    }\n\n    &__active {\n      background-color: var(--color-dark);\n      color: var(--color-white);\n      font-weight: 700;\n      transition: all 0.4s;\n    }\n  }\n}\n\n.whiteTable {\n  width: 100%;\n  margin-top: 3rem;\n  font-size: var(--default-font-small);\n  overflow-x: scroll;\n\n  &::-webkit-scrollbar {\n    width: 0;\n    height: 0.7rem;\n    background: var(--color-white);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: var(--color-grey);\n    border-radius: 2rem;\n  }\n\n  table {\n    border-collapse: collapse;\n    box-sizing: border-box;\n    text-align: left;\n    width: 100%;\n  }\n\n  tr {\n    display: flex;\n    justify-content: space-between;\n    border-bottom: 1px solid var(--color-grey-4);\n\n    & > * {\n      margin-right: 1rem;\n    }\n  }\n\n  td,\n  th {\n    line-height: 4rem;\n    padding: 2rem 0;\n    width: 100%;\n  }\n}\n\n.filter {\n  &_content {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n\n    & > :not(last-child) {\n      margin-right: 1rem;\n    }\n  }\n}\n\n.noInsights {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-error);\n  font-size: var(--default-font-subtitle);\n  text-align: center;\n  height: 70%;\n}\n\n.tableAction {\n  &__text {\n    font-weight: 700;\n    cursor: pointer;\n\n    &:hover {\n      color: var(--color-primary);\n    }\n  }\n}\n\n.status {\n  display: flex;\n  font-weight: 700;\n  justify-content: center;\n  align-items: center;\n  border-radius: 5px;\n  width: 14rem;\n  font-size: 1.2rem;\n\n  &__th {\n    display: flex;\n    justify-content: center;\n    width: 14rem;\n  }\n\n  &__dark__yellow {\n    color: var(--color-dark-yellow);\n    background-color: var(--color-light-yellow);\n    border: 0.5px solid var(--color-dark-yellow);\n  }\n\n  &__green {\n    color: var(--color-green);\n    background-color: var(--color-light-green);\n    border: 0.5px solid var(--color-green);\n  }\n\n  &__green2 {\n    color: var(--color-green);\n    background-color: var(--color-green-3);\n    border: 0.5px solid var(--color-green);\n  }\n\n  &__red {\n    color: var(--color-error);\n    background-color: var(--color-light-red);\n    border: 0.5px solid var(--color-error);\n  }\n\n  &__grey {\n    color: var(--color-grey-2);\n    background-color: var(--color-light-grey);\n    border: 0.5px solid var(--color-grey-2);\n  }\n\n  &__blue {\n    color: var(--color-primary);\n    background-color: var(--color-primary-7);\n    border: 0.5px solid var(--color-primary);\n  }\n}\n\n.cards {\n  &_green {\n    &_1 {\n      background-color: var(--color-green);\n      color: var(--color-white);\n    }\n\n    &_2 {\n      background-color: var(--color-green-2);\n    }\n\n    &_3 {\n      background-color: var(--color-success);\n      color: var(--color-white);\n    }\n  }\n\n  &_red {\n    &_1 {\n      background-color: var(--color-error);\n      color: var(--color-white);\n    }\n\n    &_2 {\n      background-color: var(--color-light-red);\n    }\n\n    &_3 {\n      background-color: var(--color-deep-red);\n      color: var(--color-white);\n    }\n\n    &_4 {\n      background-color: var(--color-red);\n      color: var(--color-white);\n    }\n\n    &_5 {\n      background-color: var(--color-red-2);\n      color: var(--color-white);\n    }\n  }\n\n  &_yellow {\n    &_1 {\n      background-color: var(--color-yellow-2);\n    }\n\n    &_2 {\n      background-color: var(--color-yellow);\n    }\n\n    &_3 {\n      background-color: var(--color-yellow-3);\n      color: var(--color-white);\n    }\n  }\n\n  &_blue {\n    &_1 {\n      background-color: var(--color-primary-3);\n    }\n\n    &_2 {\n      background-color: var(--color-primary-7);\n    }\n\n    &_3 {\n      background-color: var(--color-primary-8);\n    }\n\n    &_4 {\n      background-color: var(--color-primary-9);\n    }\n  }\n}\n\n.main {\n  &_nav {\n    display: flex;\n    margin: 2rem 0;\n    border-bottom: solid 1px var(--color-dark);\n    gap: 2rem;\n    width: fit-content;\n    flex-wrap: wrap;\n\n    &_item {\n      cursor: pointer;\n      padding: 1rem 0;\n      font-size: var(--default-font-small);\n\n      &_active {\n        cursor: pointer;\n        padding: 1rem 0;\n        font-weight: 700;\n        border-bottom: solid 2px var(--color-dark);\n      }\n\n      &:hover,\n      &:focus,\n      &:focus-visible,\n      &:focus-within {\n        font-weight: 700;\n      }\n    }\n  }\n}\n\n.error {\n  font-size: var(--default-font-small);\n  color: var(--color-error);\n  // padding-left: 2rem;\n  font-weight: 400;\n  margin: 1rem 0;\n  max-width: 38rem;\n}\n\n.font {\n  &__700 {\n    font-weight: 700;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
